import { Icon } from '@iconify/react'
import { StringParam, useQueryParam } from 'use-query-params'

import s from './ReportMessage.module.css'

type Props = {
  onClose: () => void
}

export const ReportMessage = ({ onClose }: Props) => {
  const [_, setTab] = useQueryParam('tab', StringParam)

  return (
    <div className={s.wrapper}>
      Report(s) are being generated. You can view them in
      <div
        className={s.link}
        role="none"
        onClick={() => {
          setTab('past_reports')
          onClose()
        }}
      >
        <Icon icon="lucide:file" />
        Past Reports
      </div>
    </div>
  )
}
